module.exports = __webpack_public_path__ + "img/tang-img1.cee26ea8.png";